let _metadataConfigs = [];

function add(key, fn) {
    _metadataConfigs.push({
        key,
        fn,
    });
}

function compute() {
    return _metadataConfigs.reduce((map, config) => {
        map[config.key] = config.fn();
        return map;
    }, {});
}

function clear() { // only for testing
    _metadataConfigs = [];
}

export { add };
export { clear };
export { compute };

export default {
    add,
    compute,
    clear,
};
